// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseCustomerFactory instead of class inheritance

import { createBaseCustomer, type IBaseCustomer } from "../BaseCustomerFactory";
import type { DocumentsInstance } from "./helpers/documentsInstanceHelpers";
import { createDocumentsInstance } from "./helpers/documentsInstanceHelpers";
import { createApiFactory } from "@Front/Api/helpers/BaseApiFactoryGenerator";

const factory = createApiFactory<IBaseCustomer, DocumentsInstance>({
	name: "Documents",
	createBase: createBaseCustomer,
	createInstance: createDocumentsInstance,
});

export function getDocumentsInstance(): DocumentsInstance {
	return factory.getInstance();
}
